import request from '@/utils/request'

export function getSslCertificate (id) {
  return request.get(`/ssl-certificates/${id}`)
}
